import React from 'react';
import toggleOnIcon from '../../assets/ui/toggle-on.svg';
import toggleOffIcon from '../../assets/ui/toggle-off.svg';

const Toggle = ({ 
  checked, 
  onChange, 
  label, 
  disabled = false 
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div
        style={{
          position: 'relative',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1
        }}
        onClick={disabled ? undefined : onChange}
      >
        <img
          src={checked ? toggleOnIcon : toggleOffIcon}
          alt={checked ? 'Toggle On' : 'Toggle Off'}
          style={{
            width: '46px',
            height: '18px',
            userSelect: 'none'
          }}
        />
      </div>
      <span
        style={{
          fontFamily: 'Montserrat',
          fontWeight: 'bold',
          fontSize: '14px',
          lineHeight: '18px',
          letterSpacing: '0px',
          textTransform: 'none',
          opacity: 1,
          color: checked ? '#0AD69F' : '#9a9a9a',
          textAlign: 'left'
        }}
      >
        {label}
      </span>
    </div>
  );
};

export default Toggle;
